<template>
  <div>
    <b-card title="Willkommen im Buchungsportal.">
      <b-card-text>
      </b-card-text>
      <b-button
          variant="info"
          block
          :to="{ name: 'TA-Voucher' }"
      >
        Jetzt eine Fahrt buchen
      </b-button>
    </b-card>
  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCard, BCardText, BLink,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCard,
    BCardText,
    BLink,
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Flughafenservice Rech'
    })

    console.log("TA Home Mounted Success")
  }
}
</script>

<style>

</style>
